import React, { useCallback, useEffect } from 'react';

import { Filter } from '../../../Enum/Filters';
import { Label } from '../../../Interface/Response/Interest/Label';
import LabelSelectForm from '../Form/LabelSelectForm';

import { useDispatch } from 'react-redux';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import useGetLabels from '../../../Hook/Interest/UseGetLabels';
import ModificationLoanFormFilter from './ModificationLoanFormFilter';
import { tokenExpired } from '../../../Store/Auth/action';
import { errorHasBeenThrown } from '../../../Store/Error/action';
import { getModificationLoanForms } from '../../../Service/Interest/InterestService';
import { filterChanged } from '../../../Store/Filter/action';
import { modificationLoanFormsLoaded } from '../../../Store/ModificationLoanform/action';
import { ModificationLoanForm } from '../../../Interface/Response/Interest/ModificationLoanForm';
import { ErrorResponse } from '../../../Interface/ErrorResponse';

const CombinedLabelAndModificationLoanFormFilter: React.FC = () => {
    const dispatch = useDispatch();

    const selectedLabelFindataCode = useGetFilterValue(Filter.Label);
    const selectedLabel = useGetLabels(true).allLabels.find(
        ({ findataCode }) => findataCode === selectedLabelFindataCode,
    );

    const selectLabel = useCallback(
        (label: Label): void => {
            dispatch(filterChanged(Filter.Label, label.findataCode));

            getModificationLoanForms(label.findataCode).then(
                result => dispatch(modificationLoanFormsLoaded(result)),
                (errorResult: ErrorResponse) =>
                    errorResult.code === 403
                        ? dispatch(tokenExpired())
                        : dispatch(errorHasBeenThrown(new Error(errorResult.message))),
            );
        },
        [dispatch],
    );

    const selectModificationLoanForm = useCallback(
        (loanForm: ModificationLoanForm): void => {
            dispatch(filterChanged(Filter.ModificationLoanForm, loanForm.modificationLoanFormId.toString()));
            dispatch(filterChanged(Filter.ModificationLoanFormName, loanForm.loanFormName));
        },
        [dispatch],
    );

    useEffect(() => {
        if (selectedLabel) selectLabel(selectedLabel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <LabelSelectForm onSelect={selectLabel} selectedLabel={selectedLabel} />
            <hr />
            <ModificationLoanFormFilter onSelect={selectModificationLoanForm} />
        </>
    );
};

export default CombinedLabelAndModificationLoanFormFilter;
